import type { RouteObject } from "react-router-dom";
import LimiteDeError from "../components/ui/LimiteDeError";

/**
 * Pone un `LimiteDeError` alrededor de cada ruta hija, que es lo que pinta el
 * `<Outlet />` de un layout.
 *
 * El límite de la raíz (App.tsx) atrapa cualquier fallo, pero se lleva el
 * encabezado y la barra lateral con el contenido: no queda con qué navegar y hay
 * que recargar. Con esto el fallo se queda en la sección que lo produjo y el menú
 * sigue vivo. Se hace aquí, sobre el árbol de rutas, y no en cada uno de los ~50
 * layouts: es una sola costura y ningún layout nuevo se queda sin él.
 *
 * La `key` por ruta hace que, al ir a otra sección, el límite empiece limpio en
 * vez de seguir enseñando el error de la anterior.
 */
export function withLimitesDeError(routes: RouteObject[]): RouteObject[] {
  // El primer nivel ya lo cubre el límite de la raíz.
  return routes.map((route) => (route.children ? { ...route, children: route.children.map(proteger) } : route));
}

function proteger(route: RouteObject, i: number): RouteObject {
  const children = route.children?.map(proteger);
  const element = route.element && (
    <LimiteDeError key={route.path ?? (route.index ? "indice" : i)} zona="esta sección" variante="panel">
      {route.element}
    </LimiteDeError>
  );
  return { ...route, ...(children && { children }), ...(element && { element }) } as RouteObject;
}
